import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './clientUsers.css';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { prepareClientUserData } from './clientUsersTableUtils';
import { DataTableWrapper } from '../../../utils/dataTableWrapper';
import { CandidatesTable } from '../../content-panes/admin-candidate/candidate-listing-table/candidatesTablesClient';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ClientService } from '../../../services/clientService';
import { decodeJWT } from '../../../services/candidateService';
import _ from 'lodash';
import { serverConfig } from '../../../services/server-config';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faSearch } from '@fortawesome/free-solid-svg-icons';
import searchIcon from '../../../assets/images/Ic_Search.png';
import { ClientUsersTable } from './clientUsersTable';
import ClientUserService from '../../../services/client-services/clientUserService';

const ClientUsers = () => {
    const [tableData, setTableData] = useState({ columns: [], data: [] });
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [tableRefreshTrigger, setTableRefreshTrigger] = useState(0);
    const [addName, setAddName] = useState('');
    const [addMobile, setAddMobile] = useState('');
    const [addEmail, setAddEmail] = useState('');
    const [addRole, setAddRole] = useState('');
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [confirmModalVisible, setConfirmModalVisible] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedAction, setSelectedAction] = useState(null);
    const [rowsState, setRowsState] = useState([]);
    const navigate = useNavigate();

    const handleNameClick = (username) => {
        navigate("/client/client-user-profile", {
            state: { username }
        });
    };
    const [addErrors, setAddErrors] = useState({
        name: '',
        phoneNumber: '',
        emailId: '',
        designation: ''
    });

    const validateAddUser = () => {
        const errors = {};

        if (!addName.trim()) {
            errors.name = "Name is required";
        } else if (!/^[A-Za-z ]+$/.test(addName.trim())) {
            errors.name = "Name should contain only letters and spaces";
        }

        if (!addMobile.trim()) {
            errors.phoneNumber = "Mobile number is required";
        } else if (/^0/.test(addMobile.trim())) {
            errors.phoneNumber = "Mobile number should not start with 0";
        } else if (!/^\+?[0-9]{2}[0-9]{10}$/.test(addMobile.trim())) {
            errors.phoneNumber = "Enter a valid mobile number (+919876XXXXX0)";
        }

        if (!addEmail.trim()) {
            errors.emailId = "Email is required";
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addEmail.trim())) {
            errors.emailId = "Enter a valid email address";
        }

        if (!addRole.trim()) {
            errors.designation = "Role/Designation is required";
        } else if (!/^[A-Za-z ]+$/.test(addRole.trim())) {
            errors.designation = "Role/Designation should contain only letters and spaces";
        }

        setAddErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleAddUser = async () => {
        if (!validateAddUser()) {
            return;
        }
        try {
            const payload = {
                name: addName.trim(),
                phoneNumber: addMobile.trim(),
                emailId: addEmail.trim(),
                designation: addRole.trim(),
                clientRole: "USER",

            };

            const response = await ClientUserService.addClientUser(payload);

            if (response?.status === 200) {
                closeAddUserModal();

                setAddName('');
                setAddMobile('');
                setAddEmail('');
                setAddRole('');
                setAddErrors({});
                setTableRefreshTrigger((prev) => prev + 1);

                setShowSuccessPopup(true);
            }
        } catch (error) {
            console.error("Error adding client user:", error);
        }
    };


    const fetchAllUsers = async (name = '', page = 0, size = 10) => {
        setLoading(true);
        let isActive = true;
        const abortCleanupBlobs = [];

        try {
            const resp = await ClientUserService.getAllClientUsers(name, page, size);
            const data = resp?.data || {};
            const users = data?.users || [];
            console.log("RAW API RESPONSE:", resp?.data);
            console.log("USERS ARRAY:", users);

            const pageNo = data?.pageNo ?? page;
            const pageCount = data?.pageCount ?? 0;
            const totalCount = data?.totalCount ?? 0;

            const mapped = users.map((u) => {

                const base64 = u?.dpFileContent?.[0] || null;
                return {
                    username: u.username || '',
                    name: u.name || '',
                    designation: u.designation || '',
                    phoneNumber: u.phoneNumber || '',
                    emailId: u.emailId || '',
                    clientRole: u.clientRole || '',
                    userStatus: u.userStatus || '',
                    dpFileContentBase64: base64,
                    dpPath: u.dpPath || null,
                    profileImage: base64 ? `data:image/*;base64,${base64}` : default_profile_image,
                };
            });
            console.log("MAPPED USERS:", mapped);

            if (!isActive) return;

            setRowsState(mapped);

            const prepared = prepareClientUserData(
                { users: mapped },
                openConfirmModal,
                handleNameClick
            );
            setTableData(prepared);
            console.log("PREPARED TABLE DATA:", prepared);

            setTotalEntries(totalCount);
            setTotalPages(pageCount);
            setLoading(false);

            return () => {
                isActive = false;
                abortCleanupBlobs.forEach((b) => {
                    try {
                        if (b?.startsWith('blob:')) {
                            URL.revokeObjectURL(b);
                        }
                    } catch (e) {
                    }
                });
            };
        } catch (error) {
            console.error('Error fetching client users:', error);
            setLoading(false);
        }
    };

    const fetchData = useCallback(
        async ({ pageIndex: pIndex, pageSize: pSize, searchQuery }) => {
            await fetchAllUsers(
                searchQuery ?? inputValue,
                pIndex ?? pageIndex,
                pSize ?? pageSize
            );

            return {
                pageCount: totalPages,
                totalEntries
            };
        },
        [inputValue, pageIndex, pageSize, tableRefreshTrigger]
    );

    const openConfirmModal = (username, status) => {
        setSelectedUser(username);
        setSelectedAction(status === "ACTIVE" ? "DEACTIVATE" : "ACTIVATE");
        setConfirmModalVisible(true);
    };

    const confirmStatusChange = async () => {
        try {
            if (selectedAction === "DEACTIVATE") {
                await ClientUserService.deactivateClientUser(selectedUser);
            } else {
                await ClientUserService.activateClientUser(selectedUser);
            }

            setConfirmModalVisible(false);
            setSelectedUser(null);
            setSelectedAction(null);
            setTableRefreshTrigger(prev => prev + 1);
        } catch (err) {
            console.error("Error updating status:", err);
        }
    };

    const handleSearch = () => {
        setPageIndex(0);
        fetchAllUsers(inputValue.trim() || '', 0, pageSize);
    };
    useEffect(() => {
        fetchAllUsers(inputValue.trim(), pageIndex, pageSize);
    }, [pageIndex, tableRefreshTrigger]);
    const openAddUserModal = () => setShowModal(true);
    const closeAddUserModal = () => setShowModal(false);

    return (
        <Container fluid className="container-styles" style={{ minHeight: '600px' }}>
            {loading && (
                <div className="mycandidates-loader-container">
                    <div className="mycandidates-loader"></div>
                </div>
            )}

            <div className="client-user-landing-page-header">
                <h3 style={{fontWeight :'600'}} className="client-user-landing-page-heading">Client Users</h3>
                <div className="add-user-search-bar">
                    <button className="add-user-search-button" onClick={openAddUserModal}>
                        Add User
                    </button>
                    {showModal && (
                        <div className="add-user-overlay">
                            <div className="add-user-modal">
                                <h2 className="add-user-title">Add User</h2>
                                <div className="add-user-body">
                                    <div className="add-user-row">
                                        <div className="add-user-input-wrapper">
                                            <label className="add-user-label">Name</label>
                                            <input
                                                className="add-user-input"
                                                type="text"
                                                placeholder="Enter Name"
                                                spellCheck="false"
                                                value={addName}
                                                onChange={(e) => setAddName(e.target.value)}
                                            />
                                            {addErrors.name && <p className="error">{addErrors.name}</p>}

                                        </div>
                                        <div className="add-user-input-wrapper">
                                            <label className="add-user-label">Mobile Number</label>
                                            <input
                                                className="add-user-input"
                                                type="text"
                                                spellCheck="false"
                                                placeholder="Enter Mobile Number"
                                                value={addMobile}
                                                onChange={(e) => setAddMobile(e.target.value)}
                                            />
                                            {addErrors.phoneNumber && <p className="error">{addErrors.phoneNumber}</p>}

                                        </div>
                                    </div>
                                    <div className="add-user-row">
                                        <div className="add-user-input-wrapper">
                                            <label className="add-user-label">Email ID</label>
                                            <input
                                                className="add-user-input"
                                                type="email"
                                                spellCheck="false"
                                                placeholder="Enter Email ID"
                                                value={addEmail}
                                                onChange={(e) => setAddEmail(e.target.value)}
                                            />
                                            {addErrors.emailId && <p className="error">{addErrors.emailId}</p>}
                                        </div>
                                        <div className="add-user-input-wrapper">
                                            <label className="add-user-label">Role</label>
                                            <input
                                                className="add-user-input"
                                                type="text"
                                                spellCheck="false"
                                                placeholder="Enter Role/Designation"
                                                value={addRole}
                                                onChange={(e) => setAddRole(e.target.value)}
                                            />
                                            {addErrors.designation && <p className="error">{addErrors.designation}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="add-user-footer">
                                    <button className="add-user-cancel-btn" onClick={closeAddUserModal}>
                                        Cancel
                                    </button>
                                    <button className="add-user-save-btn" onClick={handleAddUser}>Add</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showSuccessPopup && (
                        <div className="add-user-overlay">
                            <div className="add-user-modal">
                                <div
                                    style={{ fontWeight: 600, fontSize: 20, color: '#F35824', cursor: 'pointer' }}
                                    onClick={() => setShowSuccessPopup(false)}
                                >
                                    ✕
                                </div>

                                <h2 className="add-user-title">User Added Successfully</h2>

                                <div className="add-user-body" style={{ textAlign: "center" }}>
                                    <p style={{ fontSize: 16, marginBottom: 10 }}>User has been added.</p>
                                    <p style={{ fontSize: 16 }}>An email has been sent to the user.</p>
                                </div>

                                <div className="add-user-footer" style={{ justifyContent: "center" }}>
                                    <button
                                        className="add-user-save-btn"
                                        onClick={() => setShowSuccessPopup(false)}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="candidate-search-field" style={{ marginLeft: 12 }}>
                        <input
                            type="text"
                            placeholder="Search by name"
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);

                                if (e.target.value.trim() === '') {
                                    fetchAllUsers('', 0, pageSize);
                                    setPageIndex(0);
                                }
                            }}
                            onKeyDown={(evt) => {
                                if (evt.key === 'Enter') handleSearch();
                            }}
                            spellCheck={false}
                        />
                        <img
                            src={require('../../../assets/images/Ic_Search.png')}
                            alt="Search"
                            className="search-icon"
                            onClick={handleSearch}
                        />
                    </div>
                </div>
            </div>

            <hr className="candidate-landing-page-hr" />

            <div style={{ marginTop: 12 }}>
                <div className="entry-info-search">
                    <span>
                        Showing {totalEntries === 0 ? 0 : pageIndex * pageSize + 1} to{' '}
                        {Math.min((pageIndex + 1) * pageSize, totalEntries)} of {totalEntries} entries
                    </span>
                </div>

                <DataTableWrapper>
                    <ClientUsersTable
                        columns={tableData.columns}
                        data={tableData.data}
                        pageIndex={pageIndex}
                        setPageIndex={setPageIndex}
                        pageCount={totalPages}
                        fetchData={fetchData}
                        queryValue={inputValue}
                        tableRefreshTrigger={tableRefreshTrigger}
                        onNameClick={handleNameClick}
                    />
                </DataTableWrapper>
            </div>
            {confirmModalVisible && (
                <div className="add-user-overlay">
                    <div className="add-user-modal">
                        <h2 className="add-user-title">
                            {selectedAction === "DEACTIVATE"
                                ? "Deactivate User"
                                : "Activate User"}
                        </h2>

                        <div className="add-user-body" style={{ textAlign: "center" }}>
                            <p style={{ fontSize: 16, marginBottom: 10 }}>
                                Are you sure you want to {selectedAction === "DEACTIVATE" ? "deactivate" : "activate"} this user?
                            </p>
                        </div>

                        <div className="add-user-footer" style={{ justifyContent: "center", gap: 20 }}>
                            <button
                                className="add-user-cancel-btn"
                                onClick={() => setConfirmModalVisible(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="add-user-save-btn"
                                onClick={confirmStatusChange}
                            >
                                Yes, {selectedAction === "DEACTIVATE" ? "Deactivate" : "Activate"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </Container>
    );
};

export default ClientUsers;